import React from 'react';
import MissionDetail from './MissionDetail';
import missionsData from '../data/missions.json';

function MissionYouthDevelopment() {
  return <MissionDetail mission={missionsData.youthDevelopment} />;
}

export default MissionYouthDevelopment;
